import React, { useState } from "react";
import { motion } from "framer-motion";

const FAQ = () => {
    // State to manage open/close for each FAQ
    const [openIndex, setOpenIndex] = useState(null);

    // Toggle function
    const toggleFAQ = (index) => {
        setOpenIndex(openIndex === index ? null : index);
    };

    // Animation Variants
    const fadeIn = {
        hidden: { opacity: 0, y: 50 },
        visible: { opacity: 1, y: 0, transition: { duration: 0.8, ease: "easeOut" } },
    };

    // FAQ Data
    const faqData = [
        {
            category: "Residential Glass FAQs",
            questions: [
                {
                    question: "What types of residential glass services do you offer?",
                    answer:
                        "We provide window repair, replacement, and installation services for homes, including energy-efficient options and custom glass work.",
                },
                {
                    question: "How long does a typical residential window replacement take?",
                    answer:
                        "The duration depends on the size of the project, but most replacements can be completed within a day.",
                },
                {
                    question: "Do you offer emergency glass repair services for homes?",
                    answer:
                        "Yes, we provide 24/7 emergency glass repair services to ensure your home remains secure.",
                },
                {
                    question: "What kind of warranty do you offer for residential glass installations?",
                    answer:
                        "We offer a comprehensive warranty covering both materials and labor for all our installations.",
                },
            ],
        },
        {
            category: "Auto Glass FAQs",
            questions: [
                {
                    question: "Do you offer mobile auto glass replacement services?",
                    answer:
                        "Yes, we provide mobile services where our technicians come to your location to replace your auto glass.",
                },
                {
                    question:
                        "Will my insurance rates increase if I file a claim for windshield repair or replacement?",
                    answer:
                        "Generally, insurance rates do not increase for glass-only claims.",
                },
                {
                    question: "How long does a typical windshield replacement take?",
                    answer:
                        "Most windshield replacements can be completed within 30 minutes to an hour.",
                },
                {
                    question: "Do you offer a warranty for auto glass repairs and replacements?",
                    answer:
                        "Yes, we offer a warranty that covers both materials and labor for all our auto glass installations.",
                },
            ],
        },{
            category: "Commercial Glass FAQs", 
            questions:[{
                question:"What types of commercial glass services do you provide?",
                answer:"We offer a range of services including storefront glass installation, window repair, and custom glass solutions for businesses."
            },{
                question:"How quickly can you respond to a commercial glass emergency?",
                answer:"We prioritize emergency requests and typically respond within a few hours."
            },{
                question:"Do you provide glass solutions for high-rise buildings?",
                answer:"Yes, we have experience working with high-rise buildings and can provide tailored glass solutions."
            },{
                question:"What safety measures do you take during commercial glass installations?",
                answer:"We follow strict safety protocols and use high-quality materials to ensure the safety and durability of our installations."
            }]
        },{
        category: "General FAQs",
        questions: [
            {
                question:"Do you accept insurance for glass repairs and replacements?",
                answer:"Yes, we work with most insurance companies and can help you file a claim."
            },
            {
                question:"Can I get a free quote for glass services?",
                answer:"Yes, we offer free estimates for all our services. Just contact us with your requirements."
            },
            {
                question:"Do you offer custom glass work?",
            answer:"Yes, we can create custom glass solutions tailored to your specific needs."}
        ]
        // Add more categories as needed...
}];

    return (
        <motion.div
            className="bg-secondary w-full p-8 md:p-24"
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true }}
            variants={fadeIn}
        >
            <h2 className="text-3xl md:text-4xl font-playfair-display text-primary mb-8">
                Frequently Asked Questions
            </h2>
            <div className="flex flex-col gap-6">
                {faqData.map((category, categoryIndex) => (
                    <div key={categoryIndex} className="bg-white p-6 rounded-md shadow-md">
                        <h3 className="text-xl font-bold mb-4">{category.category}</h3>
                        {category.questions.map((faq, index) => (
                            <div key={index} className="border-b border-gray-200">
                                <button
                                    onClick={() => toggleFAQ(`${categoryIndex}-${index}`)}
                                    className="w-full flex justify-between items-center py-4 text-left text-lg font-nunito-sans text-primary focus:outline-none"
                                >
                                    {faq.question}
                                    <span className="text-primary">
                                        {openIndex === `${categoryIndex}-${index}` ? "-" : "+"}
                                    </span>
                                </button>
                                {openIndex === `${categoryIndex}-${index}` && (
                                    <motion.div
                                        initial={{ height: 0 }}
                                        animate={{ height: "auto" }}
                                        transition={{ duration: 0.3 }}
                                        className="overflow-hidden pl-4 pb-4 text-sm text-gray-600"
                                    >
                                        {faq.answer}
                                    </motion.div>
                                )}
                            </div>
                        ))}
                    </div>
                ))}
            </div>
        </motion.div>
    );
};

export default FAQ;
